import { defineStore } from 'pinia'

import { budgetApi, type BudgetUser } from '../services/budget-api'

const accessTokenKey = 'budget-quotidien-access-token'
const refreshTokenKey = 'budget-quotidien-refresh-token'

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      user: null as BudgetUser | null,
      accessToken: localStorage.getItem(accessTokenKey) || '',
      refreshToken: localStorage.getItem(refreshTokenKey) || '',
      isLoading: false,
    }
  },

  getters: {
    isAuthenticated: (state) => Boolean(state.accessToken),
  },

  actions: {
    setTokens(tokens: { access: string; refresh: string }) {
      this.accessToken = tokens.access
      this.refreshToken = tokens.refresh
      localStorage.setItem(accessTokenKey, tokens.access)
      localStorage.setItem(refreshTokenKey, tokens.refresh)
    },

    clearSession() {
      this.user = null
      this.accessToken = ''
      this.refreshToken = ''
      localStorage.removeItem(accessTokenKey)
      localStorage.removeItem(refreshTokenKey)
    },

    async login(username: string, password: string) {
      this.isLoading = true

      try {
        const tokens = await budgetApi.login({ username, password })
        this.setTokens(tokens)
        await this.fetchCurrentUser()
      } finally {
        this.isLoading = false
      }
    },

    async fetchCurrentUser() {
      if (!this.accessToken) {
        return null
      }

      this.user = await budgetApi.me()
      return this.user
    },

    logout() {
      this.clearSession()
    },
  },
})
